<template>
  <vch-modal :open="modalOpen" @closed="closeModal" :closeAriaLabel="closeAriaLabel" :busName="modalBusName" :modal-heading-aria-label="modalHeadingAriaLabel"
    displayType="video">
    <div class="vchy-video-modal">
      <iframe v-if="videoSrc" :src="videoSrc" title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
    <div class="vch-video-content__transcript mt-xxs" v-if="transcript">
      <details class="vchy-details vchy-details--transcript" v-vch-accordion>
        <summary class="vchy-details__summary">
          <span>{{ transcriptHeader }}</span>
          <svg class="vchy-details__toggle" aria-hidden="true" width="24" height="24">
            <use href="/assets/sprite/icons.svg#arrow-black"></use>
          </svg>
        </summary>
        <div class="vchy-details__contents">
          <p class="text-large mb-xxs" v-html="transcript" />
        </div>
      </details>
    </div>
  </vch-modal>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/video-popin/video-popin';

export default {
  name: 'vch-video-modal',
  props: {
    closeAriaLabel: {
      type: String,
      required: false,
    },
    privateBrowsing: {
      type: Boolean,
      required: false,
      default: true,
    },
    transcriptHeader: {
      type: String,
      required: true,
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: true,
    },
    modalHeadingAriaLabel:{
      type: String,
      required: false,
      default: 'Modal heading',
    },
  },
  data() {
    return {
      modalOpen: false,
      modalBusName: busName,
      videoSrc: '',
      transcript: '',
      launchingElement: null,
    };
  },
  mounted() {
    eventBus.$on(`${this.modalBusName}::open`, this.openModal);
    eventBus.$on(`${this.modalBusName}::close`, this.closeModal);
  },
  methods: {
    closeModal() {
      this.videoSrc = null;
      this.modalOpen = false;

      try {
        if (this.launchingElement) this.launchingElement.focus();
      } catch (e) {
        console.error('could not restore focus');
      }
    },
    openModal(config, element) {
      this.launchingElement = element;
      if (!config.vid) return;
      this.transcript = config.transcript;
      this.videoSrc = `https://www.${this.privateBrowsing ? 'youtube-nocookie' : 'youtube'
        }.com/embed/${config.vid}${this.autoPlay ? '?autoplay=1' : ''}`;
      this.modalOpen = true;
    },
  },
};
</script>

<style lang="scss" src="./video-modal.scss"></style>
